import React from 'react'

class CsvTableRow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            checked: this.props.checked
        }
    }



    toggleCheck(event) {
        event.stopPropagation();
        this.props.handleListChange(this.props.filename, !this.state.checked ? 'add' : 'remove');

        this.setState({checked: !this.state.checked});
    }

    render() {
        const {filename, checked} = this.props;
        return (
            <tr onClick={event => this.toggleCheck(event)}>
                <td>
                    <input type="checkbox" onClick={event => this.toggleCheck(event)} checked={this.state.checked}/>
                </td>
                <td>
                    {filename}
                </td>
            </tr>
        )
    }
}

export default CsvTableRow


// WEBPACK FOOTER //
// ./src/components/admin/data-import/csv-table-row.jsx